import React from 'react';
import './MessagePanel.css'

const MessagePanel = (messages = []) => {
  return (
    <div className='baseLayout'>
      <div className='messagePanelContent'>
        <ul>
          {messages.messages.map(message => {
            if (Date.now() >= message.displayFrom & Date.now() <= message.displayTo) {
              return (
                <li>
                  <p>
                    {message.content}
                  </p>

                </li>
              )
            } else {
              return (
                <></>
              )
            }

          })}

        </ul>

      </div>

    </div>
  )
}

export default MessagePanel